/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type DeleteVolunteerShiftMutationVariables = Types.Exact<{
  shiftId: Types.Scalars["Int"];
}>;

export type DeleteVolunteerShiftMutation = {
  deleteVolunteerShift: Pick<Types.Success, "status">;
};

export const DeleteVolunteerShiftDocument = gql`
  mutation DeleteVolunteerShift($shiftId: Int!) {
    deleteVolunteerShift(id: $shiftId) {
      status
    }
  }
`;

/**
 * __useDeleteVolunteerShiftMutation__
 *
 * To run a mutation, you first call `useDeleteVolunteerShiftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVolunteerShiftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVolunteerShiftMutation, { data, loading, error }] = useDeleteVolunteerShiftMutation({
 *   variables: {
 *      shiftId: // value for 'shiftId'
 *   },
 * });
 */
export function useDeleteVolunteerShiftMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    DeleteVolunteerShiftMutation,
    DeleteVolunteerShiftMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    DeleteVolunteerShiftMutation,
    DeleteVolunteerShiftMutationVariables
  >(DeleteVolunteerShiftDocument, baseOptions);
}
export type DeleteVolunteerShiftMutationHookResult = ReturnType<
  typeof useDeleteVolunteerShiftMutation
>;
export type DeleteVolunteerShiftMutationResult =
  ApolloReactCommon.MutationResult<DeleteVolunteerShiftMutation>;
export type DeleteVolunteerShiftMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    DeleteVolunteerShiftMutation,
    DeleteVolunteerShiftMutationVariables
  >;
